import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { siteConfig } from '@/constants/site'

interface CoverImageProps {
    src: string | null
    alt: string | null
    className?: string
    priority?: boolean
}

export const CoverImage: FC<CoverImageProps> = ({ src, alt, className, priority = false }): ReactNode => {
    if (!src) {
        return (
            <div
                aria-hidden='true'
                className={cn('flex h-full w-full items-center justify-center bg-linear-to-br from-accent via-secondary to-muted', className)}
            >
                <span className='font-heading text-3xl italic text-foreground/25'>
                    {siteConfig.name}
                    <span className='text-brand/50'>.</span>
                </span>
            </div>
        )
    }

    return (
        <img
            src={src}
            alt={alt ?? ''}
            loading={priority ? 'eager' : 'lazy'}
            fetchPriority={priority ? 'high' : 'auto'}
            decoding='async'
            className={cn('h-full w-full object-cover', className)}
        />
    )
}
